module.exports = {
    "Clear search": `Vymazat hled\xe1n\xed`
};


//# sourceMappingURL=cs-CZ.main.js.map
